import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { TransactionService } from '../../../../providers/transaction.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from "../../../../../environments/environment";
import { get, isEmpty, isUndefined, padStart } from 'lodash';
import { NgbModal,NgbActiveModal,NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/providers/common.service';
import { MessageService } from 'primeng/api';
import { ItemList } from 'src/app/core/model/itemListReceipt';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { InvoiceDetails, LineItemData, getL2L3LineItemDetails, getLineItemDetails, handleLineItemEmptyValues } from 'src/app/core/model/invoice';
import { TransactionType } from 'src/app/core/model/transaction';


@Component({
  selector: 'app-view-recepit',
  templateUrl: './view-recepit.component.html',
  styleUrls: ['./view-recepit.component.scss','./view-customer-recepit.scss'],
  providers: [
    MessageService,
]
})


export class ViewRecepitComponent implements OnInit {

  @Input() id: any;
  @Input() isCustomer: boolean;
  @Input() rrn: any;
  @Input() txName: any;
  @Input() transactionId: any;
  @Input() tpn: any;
  @Input() totalAmount: any;
  @Input() alter: boolean | string = '';
  @Input() isItemsList:boolean;
  @Input() itemDetails:ItemList;

  @ViewChild('screen') screen: ElementRef;

  @ViewChild('openEmailPopup') content: ElementRef;

  modalRef: NgbModalRef;

  receiptsendform : UntypedFormGroup;

  isSubmitted:boolean = false;
  isLoadingSpinner:boolean;
  emailIdValue: any;

  baseUrl = environment.apiUrl;
  receiptData: any;
  receiptId: any;
  receiptType: any;
  receipt_invoice:any;
  receipt_Merchant:any;
  receipttxdta:any;
  invoiceVold= "";
  logo: string | null = null
  // bloburl:any = 'bloburl';
  types = {
    MC: 'Merchant Copy',
    CC: 'Customer Copy'
  };

  isLoading: boolean = true;
  baseAmtLabel: string = 'htmlText.basAmt';
  totalPaidLabel: string = 'htmlText.total';
  isTrueCashDiscounting = false;
  promotion: any={};
  isShowPromotion=false;

  styleUrl:string;
  idType: string = 'id';
  isInvoice: boolean = false
  invoiceDetails: InvoiceDetails;
  transactionDetails = TransactionType; 
  message: any = '';
  message1: string = '';
  message2: string = '';
  message3: string = '';
  discount: number = 0;
  private isOpenUrl:Boolean = false;
  constructor( private modalService: NgbModal,public commonService: CommonService, private transactionService: TransactionService, private route: ActivatedRoute, public modal: NgbActiveModal,private messageService: MessageService,private formBuilder: UntypedFormBuilder,private router:Router) {
    this.route.queryParams
      .subscribe(async params => {
      this.alter=params.alter;
      this.idType = params.idType ? params.idType : 'id';
      if(params.isItemsList){
        this.isItemsList = true;
      }

        if (params.invoiceId) {
          this.isInvoice = true
          await this.getInvoiceById(params.invoiceId)
        }

    });
    this.isOpenUrl = window.location.href.split("/").indexOf("cr") !== -1;

   }

   closeModal(data) {
    console.log('calling close',data);
    
    // this.modal.close(data);
   }
  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.receiptId = params.get('id') || this.id;
      this.receiptType = this.types[params.get('type')];
      //console.log(this.receiptId);
      this.getReceipt(this.receiptId)


    })
    this.receiptsendform = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$')]]
    });
  }

  isValidItemDetails(){
    return this.itemDetails instanceof Object && this.itemDetails?.itemList instanceof Array;
  }


  download(file) {
    html2canvas(this.screen.nativeElement, { scrollY: 0, allowTaint: true, useCORS: true, logging: true }).then((canvas) => {
      let a = document.createElement("a");
      let x = new Date().toLocaleString();
      if (file == 'png') {
        this.pngDownload(a, canvas.toDataURL('image/png'), `${this.receipt_Merchant}_Invoice-${this.receipt_invoice}_(${this.receipttxdta}).png`);
      } else {
        this.pdfDownload(canvas.toDataURL('image/png'), `${this.receipt_Merchant}_Invoice-${this.receipt_invoice}_(${this.receipttxdta}).pdf`);
      }
    });
  }

  pngDownload(a, img, fileName) {
    a.href = img;
    a.download = fileName;
    a.webkitImageSmoothingEnabled = false;
    a.mozImageSmoothingEnabled = false;
    a.imageSmoothingEnabled = false
    a.click();
  }

  pdfDownload(imgData, fileName) {
    const doc = new jsPDF('p', 'mm');
    doc.addImage(imgData, 'PNG', 65, 0, 70, 170);
    doc.save(fileName);
    // window.open(doc.output(this.bloburl, { filename: fileName }), '_blank')
  }

  getReceipt(id) {

    console.log(this.alter);

    let serviceLink = this.isOpenUrl ? apiLinks.receipt.viewReceiptNoAuth : this.alter.toString() == 'true' ? apiLinks.receipt.alternate : apiLinks.receipt.card;
    this.baseAmtLabel = (this.alter.toString() == 'true' && this.receiptData?.txnDetails?.txName == 'CASH') ? 'htmlText.cashAmt': this.baseAmtLabel;
    console.log("🔥 ~ getReceipt ~ serviceLink:", serviceLink)
    this.commonService.getCommonHttpClientQueryParams(`${serviceLink}/${this.receiptId}`, { idType: this.idType, alter:this.alter }).subscribe(res => {
      this.receiptData = res.data;
      const rd = this.receiptData.receiptDetails;
        ['h1','h2','h3','h4','h5','h6'].forEach(key => {
          rd[key] = this.formatAddressLine(this.errorHandle(rd[key]));
      });
      this.receipt_invoice = get(res, 'data.txnDetails.invoiceNumber','');
      this.receipt_Merchant = get(res,'data.receiptDetails.h1','');
      this.receipttxdta = get(res,'data.txnDetails.txDate','');

      let tagLabel = get(this.receiptData?.signatureDetails,'tagLabel','');
      tagLabel = tagLabel ? tagLabel.toString() : '';
      let tagValue = get(this.receiptData?.signatureDetails,'tagValue','');
      tagValue = tagValue ? tagValue.toString() : '';
      if(!isEmpty(tagLabel) && !isEmpty(tagValue)){
        this.receiptData.signatureDetails.tagLabel= tagLabel.split(",");
        this.receiptData.signatureDetails.tagValue = tagValue.split(",");
      }

      if(this.isItemsList){
        this.itemDetails = get(res,'data.signatureDetails.itemDetails',{});
      }
      const misc = res.data?.miscDetails
      if (misc?.E_RCPT_IMG_URL && misc?.E_RCPT_URL) {       
        this.isShowPromotion=true;
        this.promotion['title'] = res.data?.miscDetails?.E_RCPT_TITL;
        this.promotion['message'] = res.data?.miscDetails?.E_RCPT_MSG;
        this.promotion['promotionImageUrl'] = `${this.baseUrl}/${res.data?.miscDetails?.E_RCPT_IMG_URL}`;
        let redirectParams = `promotionId=${res.data?.miscDetails?.PROMO_ID}&&promotionDetailsId=${res.data?.miscDetails?.E_PROMO_ID}&&tpn=${res.data?.txnDetails?.tpn}&&txId=${res.data?.txnDetails?.transactionId}&&redirectUrl=${res.data?.miscDetails?.E_RCPT_URL}`
        this.promotion['promotionalUrl'] = `${environment.apiUrl}/redirectPromotion?${redirectParams}`;
      }
      this.baseAmtLabel = get(this.receiptData,'signatureDetails.customField.msrpLabel', this.baseAmtLabel);
      this.discount = get(this.receiptData, 'signatureDetails.customField.loyalty.discountApplied', 0);

      // this.message = JSON.parse(get(this.receiptData, 'signatureDetails.customField.loyalty.rewardsMessage', ''));

      this.message = get(this.receiptData, 'signatureDetails.customField.loyalty.rewardsMessage', '');

      console.log("This message is for sake: ", this.message);
      
      this.message1 = get(this.receiptData, 'signatureDetails.customField.loyalty.rewardsMessage1', '');
      this.message2 = get(this.receiptData, 'signatureDetails.customField.loyalty.rewardsMessage2', '');
      this.message3 = get(this.receiptData, 'signatureDetails.customField.loyalty.rewardsMessage3', '');

      this.baseAmtLabel = !isEmpty(this.baseAmtLabel) ? this.baseAmtLabel : 'htmlText.basAmt';
      this.isTrueCashDiscounting = get(this.receiptData,'signatureDetails.customField.feeType', false) === "8" ? true : false;
      let tcdCondition = get(this.receiptData,'signatureDetails.customField.feeType', false) == '8' && this.alter.toString() == 'true' && get(this.receiptData, 'txnDetails.transactionType',false) != 'GIFT';
      this.totalPaidLabel = tcdCondition ? 'Cash Paid': this.totalPaidLabel;
      this.getImage() 
      this.getInvoice(this.receiptData);
      this.isLoading = false;
    }, (error) => {
      if (this.isOpenUrl) {
        const msgbj = { icon: "notify.svg", message: error.message };
        this.router.navigateByUrl(`/message/${window.btoa(JSON.stringify(msgbj))}`);
      } else {
        this.messageService.add({
          severity: "error",
          detail: error.message || "Server Error !",
          sticky: true
        });
      }       
      
    });
  }

  //get invoice number 
  getInvoice(receiptDate) {
    let params = {
      rrn: receiptDate.txnDetails.rrn,
      txName: receiptDate.txnDetails.txName,
    }
    this.transactionService.getInvoiceNum(this.transactionService.getInvoice, params).subscribe(res => {
      (!isEmpty(res?.invoiceNumber)) ? this.invoiceVold = res.invoiceNumber : this.invoiceVold = '';
    });
  }

  timeSub(time) {
    if(isEmpty(time)) {
      return "";
    }
    let txTime = time.substring(0, time.length - 3);
    return txTime;
  }



  //check flag condition for invoice show
  get(invoice, flag) {
    return (flag == 'Y') ? this.invoiceVold : invoice
  }

  getImage() {
    // console.log("image", image);
    const storeLogo = this.receiptData.defaultLogo?.storeLogo;
    const merchantLogo = this.receiptData.defaultLogo?.merchantLogo;
    this.logo = storeLogo || merchantLogo ? `${environment.portalMerchantLogoPath}/${storeLogo ?? merchantLogo}` : '';
  }
  
  transMode(EntryMode) {
    let entryMode = EntryMode.substring(0, 2);
    return entryMode == "90" ? "SWIPE"
      : entryMode == "80" ? "SWIPE"
        : entryMode == "05" ? "CHIP"
          : entryMode == "01" ? "MANUAL"
          :entryMode == "10" ? "COF"
            : entryMode == "07" ? "CONTACTLESS"
            : entryMode == "91" ? "CONTACTLESS"
              : entryMode == "11" ? "CONTACTLESS"
              : entryMode == "71" ? "CONTACTLESS"
              : EntryMode == "004" ? "CHECK"
                : ""
  }

  transType(data) {
    console.log("trans Type", data);
    return (data == "DEBIT") ? "DEBIT"
            : ""
  }

  maskedPan(cardNumber) {
    //  return cardNumber
      return cardNumber.replace(/\w(?=\w{4})/g, "*");
    }
  
    cardLabel(cardLabel, transactionType){
      return (transactionType == "DEBIT") ? "DEBIT"
             : cardLabel
    }

  approval(approvalCode, txName, hostResponseCode){
    return (txName == "TICKET") ? "Local"
    : (hostResponseCode == "10") ? ""
    : approvalCode
  }

  transAmount(data, isDiscountFee=false) {
    if(isDiscountFee) {
      data = (data / 100);
      data = data > 0 ? - data : data;
      return data;
    }
    return (data / 100);
  }

  isShowTax(amount, haciendaStatus = '', txName = '') {
    return ( amount || amount == 0 ) && (haciendaStatus == '1' ? amount >= 0 : amount != 0);
  }

  isApproval(data) {
    return ["00","0000","000","003","00000","785"].indexOf(data) >= 0? "APPROVED"
      : data == null ? ""
      : data == "85" ? "CARD OK"
      : data == "10"  || data == "002" ? "PARTIAL APPROVAL"
        : "Declined"
  }

  sumTip(tipAmount, tipAdjust, tipAmountFee) {
    return (tipAmount + tipAdjust + tipAmountFee)
  }

  sumAmount(baseAmount, feeAmount) {
    return !isUndefined(feeAmount) ? (Number(baseAmount) + Number(feeAmount)) : baseAmount ;
  }

  errorHandleF(data) {
    return (data == null || data == "")? "" : data;
  }

  errorHandle(data) {
    return (data == null || data == "")? "" : data;
  }

  defaultName(data) {
    return (data == null || data == "")? "Fee" : data;
  }

  defaultLTL(data) {
    return (data == null || data == "")? "Local Tax" : data;
  }

  defaultSTL(data) {
    return (data == null || data == "")? "State Tax" : data;
  }

  defaultRTL(data) {
    return (data == null || data == "")? "RTax" : data;
  }

  
  defaultMFL(data) {
    return (data == null || data == "")? "Fee" : data;
  }

  defaultSCH(data) {
    return (data == null || data == "")? "Fee" : data;
  }

  cardholderName(data) {
    return (data == null || data == "")? "" : data;
  }

  pinBlock(pinBlock) {
    let result;
    switch (pinBlock) {
      case '0':
        result = ""
        break;
      case 'XXXXXXXXXXXXXXXX':
        result = ""
        break;
      case 'NOCVM':
        result = ""
        break;
      default:
        result = "PIN VERIFIED OK"
        break;
    }

    return result;
  }

  ebt_type(trans_type, processorCode) {
    return (processorCode == '000000') ? "Food"
    : (processorCode == '090000') ? "Cash"
    : ""
  }

    // new
    getEmv(data:any) {
      if(!isEmpty(data)){
        return (data['9F26']) ? data['9F26'] : "";
      }else {
        return ""
      }
    }
  

  cashDis(disLabel){
    return (disLabel == null || disLabel == "")? "Cashback" : disLabel;
  }

  // getTxName(txName, ProcessCode, flag) {
  //   return (ProcessCode == '090000' && flag == 'Y') ? "EBT CASH"
  //   : (ProcessCode == '000000' && flag == 'Y') ? "EBT FOOD"
  //   : txName
  // }
  getTxName(txName : string, txType : string) {
    //console.log(txName);
    if (this.receiptData.txnDetails.voidFlag == 'Y') {
     txName = (txName == "VOID SALE") ? "SALE"
      : this.receiptData?.txnDetails?.txName
    txName = (txName == "VOID PREAUTH") ? "PREAUTH"
      : this.receiptData?.txnDetails?.txName
    }
     txName = txType == 'DEBIT' ? txName = 'DEBIT  ' + txName : txName;
     return txName;
   }

  txHandle(data) {
    return (data == null || data == "") ? "" : data;
  }

  getFeeDetails(feeDetails, txDetails){
    let isFeeEnabled = feeDetails?.FEE;
    let feeType = feeDetails?.F_TYP;
    let forCustomFeeDiscloseFeeEnabled = feeDetails?.CF_DFC;
    let forSurchargeFeeDiscloseFeeEnabled = feeDetails?.SR_DF_CUS;
    let {
      localTaxAmount = 0,stateTaxAmount= 0,commercialTaxAmount= 0
    } = txDetails;
    let totalTaxAmt = Number(localTaxAmount) + Number(stateTaxAmount) + Number(commercialTaxAmount);
    if(isFeeEnabled == 1 && txDetails.tipAmount == 0 && txDetails.tipAdjAmount == 0){
      if(forCustomFeeDiscloseFeeEnabled == 0 || forSurchargeFeeDiscloseFeeEnabled == 0){
        if(txDetails.customFee != 0 || txDetails.surcharge != 0 || txDetails.serviceFee != 0 || txDetails.LTaxFee != 0 || txDetails.GTaxFee != 0) { return true } else {
          if(txDetails.localTaxAmount != 0 || txDetails.stateTaxAmount != 0){
            return true;
          }else{
            return false;
          }
        }
      } else {
        if((feeType == 4|| feeType == 7|| feeType == 8) && totalTaxAmt == 0){
          return false;
        }else{
          return true;
        }
      }
    } else {
      return true;
    }
  }
  showMaskedCardNum(data) {
    if(isEmpty(data)) {
      return "NA";
    } else {
      return padStart(data.substring(data.length - 4), 16, '*')
    }
  }
  showBaseAmountDetails(data) {
    let txType = get(data,'transactionType', false);
    let txName = get(data,'txName','NA');
    if(!txType) {
      return false;
    } else if(txType != 'LOYALTY') {
      if(txName == 'BALANCE INQUIRY') {
        return false;
      }
      return true;
    } else if(txType == 'LOYALTY') {
      return false;
    }
    return true;
  }
  isFeeOrTaxEnabledShowTotalAmount(txnDetails) {
    let {
      localTaxAmount = 0,stateTaxAmount= 0,commercialTaxAmount= 0,LTaxFee= 0,GTaxFee= 0,CTaxFee= 0,
      customFee= 0,merchantFee= 0,serviceFee= 0,DiscountFee= 0,TxAmountFee= 0,TipAmountFee= 0,
    } = txnDetails;
    let totalFeeTaxAmt = Number(localTaxAmount) +Number(stateTaxAmount)+Number(commercialTaxAmount)+Number(LTaxFee)+Number(GTaxFee)+Number(CTaxFee)+
      Number(customFee)+Number(merchantFee)+Number(serviceFee)+Number(DiscountFee)+Number(TxAmountFee)+Number(TipAmountFee);
      return totalFeeTaxAmt > 0 ? true : false;
  }

  printPage(){
    window.print(); 
}

emailPopupModal() { 
  this.modalRef = this.modalService.open(this.content, {ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
  this.modalRef.result.then(result =>
    this.receiptsendform.reset()
    )
}

showToaster(type: string, message: string) {
  this.messageService.add({
    severity: type,
    detail: message,
  });
}

get find() { 
  return this.receiptsendform.controls; 
}

onSubmitForm() {
  if (this.receiptsendform.invalid) {
    return;
  }
  this.isSubmitted = true;
  this.isLoadingSpinner = true;
  this.emailIdValue = this.receiptsendform.value.email;
  if (this.emailIdValue) {
   
    let queryParams = { email: this.emailIdValue, id: this.id, txId: this.transactionId, tpn: this.tpn, description: "", toAmt: this.totalAmount, alter: this.alter };
    if(this.isItemsList){
      queryParams['isItemsList'] = true;
    }
    // console.log("queryParams",queryParams);
    this.commonService.getCommonHttpClientQueryParams(`${environment.apiUrl}/resendReceiptFromPortal?`, queryParams).subscribe(data => { 
      this.isLoadingSpinner = false;
      this.receiptsendform.reset();
      this.modalRef.close();
      this.isSubmitted = false;
      if (data){
        this.showToaster('success', 'Mail sent successfuly');
      }
    },
    err => {
      this.isLoadingSpinner = false;
      this.receiptsendform.reset();
      this.modalRef.close();
      this.isSubmitted = false;
      this.showToaster("error",err.message);
    })
  }

}

  lineItemsArray: LineItemData[] = []
  itemizedDetails = {
    totalTax: 0,
    totalDiscount: 0,
    totalBaseAmount: 0,
    totalAmount: 0,
    shippingFee: 0
  }
  async getInvoiceById(id) {
    try {

      const invoice = await this.commonService.getCommonHttpClientQueryParams(apiLinks.getInvoiceById, {
        id
      }).toPromise()
      this.invoiceDetails = invoice.invoiceDetails as InvoiceDetails

      const lineitems = getL2L3LineItemDetails(this.invoiceDetails.items.itemsList)


      for (let i = 0; i < lineitems.length; i++) {
        handleLineItemEmptyValues(lineitems[i].lineItemData)
      }

      const { lineItemsArray, totalAmount, totalDiscount, totalTax, totalBaseAmount } = getLineItemDetails(lineitems)
      this.itemizedDetails.totalTax = totalTax
      this.itemizedDetails.totalDiscount = totalDiscount
      this.itemizedDetails.totalBaseAmount = totalBaseAmount
      this.itemizedDetails.shippingFee = this.invoiceDetails?.items?.shippingFee ? parseInt(this.invoiceDetails?.items?.shippingFee) : 0
      console.log("🔥 ~ getInvoiceById ~ this.invoiceDetails?.items?.shippingFee:", this.invoiceDetails?.items?.shippingFee)
      if (this.invoiceDetails?.items?.shippingFee) {
        this.itemizedDetails.totalBaseAmount += parseInt(this.invoiceDetails?.items?.shippingFee)
      } 
      this.itemizedDetails.totalAmount = totalAmount


      console.log("🔥 ~ getInvoiceById ~ lineItemsArray, totalAmount, totalDiscount, totalTax:", lineItemsArray, totalAmount, totalDiscount, totalTax, totalBaseAmount)
      // console.log("🔥 ~ getInvoiceById ~ invoice:", invoice)
      this.lineItemsArray = lineItemsArray
    }
    catch (err) {
      this.isInvoice = false
    }

  }

  get isCheckTrans(): boolean {
    return this.transactionService.isCheckTrans(this.receiptData?.txnDetails || '');
  }

  get isNotCheckTrans(): boolean {
    return !this.isCheckTrans;
  }

  /** Parses MARIA tsysRespData for ARL / ARAgrRefNo / frozen TAG_ARL; Mongo RECEIPT.TAG_ARL gates display. */
  private parseTsysRespDataForReceipt(): Record<string, unknown> {
    const raw = get(this.receiptData, 'txnDetails.tsysRespData');
    if (raw == null || raw === undefined) {
      return {};
    }
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw) as Record<string, unknown>;
      } catch {
        return {};
      }
    }
    return raw as Record<string, unknown>;
  }

  /** Host/XML may wrap values in { _ } / [#text]; agreement key may vary. */
  private tsysScalarToString(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (typeof value === 'number' && !Number.isNaN(value)) {
      return String(value).trim();
    }
    if (typeof value === 'string') {
      return value.trim();
    }
    if (Array.isArray(value) && value.length > 0) {
      return this.tsysScalarToString(value[0]);
    }
    if (typeof value === 'object') {
      const o = value as Record<string, unknown>;
      if ('_' in o) {
        return this.tsysScalarToString(o['_']);
      }
      if ('#text' in o) {
        return this.tsysScalarToString(o['#text']);
      }
    }
    return '';
  }

  private agreementRefFromParsedTsys(tsys: Record<string, unknown>): string {
    const keys = ['ARAgrRefNo', 'AgrRefNo', 'AggrRefNo', 'agrRefNo', 'araGrRefNo', 'AUTO_RENT_AGR_REF'];
    for (const k of keys) {
      const s = this.tsysScalarToString(tsys[k]);
      if (s) {
        return s;
      }
    }
    const nestedBuckets = ['hostResponse', 'HostResponse', 'Response', 'TransactionResponse', '$'];
    for (const b of nestedBuckets) {
      const inner = tsys[b];
      if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
        const innerObj = inner as Record<string, unknown>;
        for (const k of keys) {
          const s = this.tsysScalarToString(innerObj[k]);
          if (s) {
            return s;
          }
        }
      }
    }
    return '';
  }

  merchantRentalAgreementRefNo(): string {
    const fromApi = get(this.receiptData, 'merchantRentalAgreementRef');
    if (fromApi !== undefined && fromApi !== null && String(fromApi).trim() !== '') {
      return String(fromApi).trim();
    }
    return this.agreementRefFromParsedTsys(this.parseTsysRespDataForReceipt());
  }

  /** Full-page receipt: match modal — long refs break after 9 chars for layout/print. */
  formatMerchantRentalAgreementRefForReceipt(): string {
    const ref = this.merchantRentalAgreementRefNo();
    if (!ref || ref.length <= 9) {
      return ref || '';
    }
    return `${ref.slice(0, 9)}\n${ref.slice(9)}`;
  }

  /** Mongo: TAG_ARL only in RECEIPT section (Steam templateValueJson.RECEIPT). */
  private mongoTagArlOne(): boolean {
    return String(get(this.receiptData, 'receiptDetails.TAG_ARL', '0')).trim() === '1';
  }

  /** Auto Rental Details: Mongo RECEIPT.TAG_ARL must be 1; then txn snapshot / API; no line when Mongo is 0. */
  private effectiveMerchantReceiptTagArl(): string {
    if (!this.mongoTagArlOne()) {
      return '0';
    }
    const tsys = this.parseTsysRespDataForReceipt();
    const snap = tsys['TAG_ARL'];
    const snapS = snap !== undefined && snap !== null ? String(snap).trim() : '';
    if (snapS === '1' || snapS === '0') {
      return snapS;
    }
    const apiVal = get(this.receiptData, 'merchantReceiptTagArl');
    if (apiVal !== undefined && apiVal !== null && String(apiVal).trim() !== '') {
      return String(apiVal).trim() === '1' ? '1' : '0';
    }
    return '1';
  }

  /** tsysRespData.ARL === N means processor auto-rental is off; hide line even if TAG_ARL and agreement ref are set. */
  private tsysArlNegatesRentalLine(): boolean {
    const tsys = this.parseTsysRespDataForReceipt();
    return this.tsysScalarToString(tsys['ARL']).toUpperCase() === 'N';
  }

  /** Auto rental row only for SALE / PREAUTH / TICKET (VOID-prefixed variants are normalized). */
  private isAutoRentalEligibleTx(): boolean {
    const raw = get(this.receiptData, 'txnDetails.txName');
    if (raw == null || raw === undefined || String(raw).trim() === '') {
      return false;
    }
    const base = String(raw).trim().replace(/^VOID\s+/i, '');
    return ['SALE', 'PREAUTH', 'TICKET'].includes(base);
  }

  showMerchantRentalAgreementLine(): boolean {
    if (!this.receiptData || this.receiptType !== this.types.MC) {
      return false;
    }
    if (!this.isAutoRentalEligibleTx()) {
      return false;
    }
    if (this.tsysArlNegatesRentalLine()) {
      return false;
    }
    if (this.effectiveMerchantReceiptTagArl() !== '1') {
      return false;
    }
    // Non-empty ARAgrRefNo required (no row when ARL=Y, TAG_ARL=1 but agreement # blank)
    const agrRef = this.merchantRentalAgreementRefNo();
    if (!agrRef) {
      return false;
    }
    return true;
  }

  formatAddressLine(data: string): string {
    if (!data || data.trim() === '') return '';
    let formatted = data.replace(/\s+,/g, ','); 
    const parts = formatted.split(',');
    if (parts.length >= 3) {
      const zip = parts[parts.length - 1].trim();      
      const state = parts[parts.length - 2].trim();   
      const city = parts.slice(0, parts.length - 2).join(',').trim();   
      return `${city}, ${state} ${zip}`;
    }  
    return formatted.trim();
  }

}
